import { Settings } from "../settings";
import { PROVIDER_CONFIG as DMON_CONFIG } from "./Providers/Dmon/providerConfig";
import { PROVIDER_CONFIG as POPIPLAY_CONFIG } from "./Providers/PopiPlay/providerConfig";

// Explicit imports, not `require.context`: that is a webpack api and throws under Jest.
// Keyed by FOLDER NAME, which is what Settings.APP.RGS_PROVIDER holds.
const providerConfigs = {
  Dmon: DMON_CONFIG,
  PopiPlay: POPIPLAY_CONFIG,
};

export const PROVIDER_CONFIG = providerConfigs[Settings.APP?.RGS_PROVIDER];

if (!PROVIDER_CONFIG) {
  throw new Error(
    `Provider config not found for: ${Settings.APP?.RGS_PROVIDER}. Available providers: ${Object.keys(providerConfigs).join(", ")}`,
  );
}
